// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"de6e220b","453":"db061538"}[chunkId] + ".chunk.js";
};